import { FormikProps } from 'formik'
import { useContext, createContext } from 'react'

const onClipboardCopy = (text: string) => {
    navigator.clipboard.writeText(text).then(
        () => {
            /* clipboard successfully set */
        },
        () => {
            /* clipboard write failed */
        },
    )
}

const formikDirtyList = (formik: FormikProps<any>, ignoreFields?: string[], fileDirty?: boolean) => {
    const formikValues = { ...formik.values }
    const keyValues = Object.keys(formikValues)

    const dirtyKeys = keyValues.filter((keyValue) => {
        if (ignoreFields && ignoreFields.some((ignoreField) => ignoreField === keyValue)) {
            return false
        } else {
            return formikValues[keyValue] !== formik.initialValues[keyValue]
        }
    })
    const dirtyValues = dirtyKeys.map((dirtyKey) => {
        return formikValues[dirtyKey]
    })
    const initValues = dirtyKeys.map((dirtyKey) => {
        return formik.initialValues[dirtyKey]
    })

    if (fileDirty) {
        dirtyKeys.push('file')
        dirtyValues.push('')
    }

    return {
        colId: dirtyKeys.join(','),
        colVal: dirtyValues.join(','),
        befVal: initValues.join(','),
    }
}

const sleep = (ms: number) => {
    const wakeUpTime = Date.now() + ms
    while (Date.now() < wakeUpTime) {}
}

export const varHover = (hover = 1.09, tap = 0.97) => ({
    hover: { scale: hover },
    tap: { scale: tap },
})

export const SettingsContext = createContext({})

export const useSettingsContext = () => {
    const context = useContext(SettingsContext)

    if (!context) throw new Error('useSettingsContext must be use inside SettingsProvider')

    return context
}

export function localStorageAvailable() {
    try {
        const key = '__some_random_key_you_are_not_going_to_use__'
        window.localStorage.setItem(key, key)
        window.localStorage.removeItem(key)
        return true
    } catch (error) {
        return false
    }
}

export function localStorageGetItem(key: string, defaultValue = '') {
    const storageAvailable = localStorageAvailable()

    let value

    if (storageAvailable) {
        value = localStorage.getItem(key) || defaultValue
    }

    return value
}

export { onClipboardCopy, formikDirtyList, sleep }
